export default __webpack_public_path__ + "static/media/weezaccess-logo.5661d7bc.png";